import { DashboardChecksTypeEnum } from "@payping/api";
import { useAppSelector } from "@/utils";

// TODO MAKE IT HOOK
export function isBirthCertificateDisabled() {
  const checks = useAppSelector((state) => state.user.checks);
  // TODO: this should merge with isPersonalDisabled
  const isBirthCertDisabled = checks?.birthCertificateStatus === DashboardChecksTypeEnum.Confirmed;
  return isBirthCertDisabled;
}
